import { APICall } from ".";

export const ax_myReservations = async (email) => {
  try {
    const res = await APICall.get(`/api/get/myReservations?email=${email}`);
    if (res.status === 200 || res.status === 201) {
      //   console.log("res - api addBooking --> " + JSON.stringify(res.data));
      return res.data;
    }
    return null;
  } catch (e) {
    console.log("e.response.data -> ", JSON.stringify(e.response));
    if (e.response.status === 404) return e.response.data;
    else return null;
  }
};

export const ax_addBooking = async (data) => {
  try {
    const res = await APICall.post("/api/post/addBooking", data);
    if (res.status === 200 || res.status === 201) {
      console.log("res - api addBooking --> " + JSON.stringify(res.data));
      return res.data;
    }
    return null;
  } catch (e) {
    console.log("e.response.data -> ", JSON.stringify(e.response));
    if (e.response.status === 404) return e.response.data;
    else return null;
  }
};

export const ax_updateBooking = async (data) => {
  try {
    const res = await APICall.put("/api/put/Booking", data);
    if (res.status === 200 || res.status === 201) {
      console.log("res - api updateBooking --> " + JSON.stringify(res));
      return res.data;
    }
    return null;
  } catch (e) {
    console.log("e.response.data -> ", JSON.stringify(e.response));
    if (e.response.status === 404) return e.response.data;
    else return null;
  }
};

export const ax_cancelBooking = async (route, id) => {
  try {
    const res = await APICall.delete(`/api/delete/${route}/${id}`);
    if (res.status === 200 || res.status === 201) {
      console.log("res - api cancelBooking --> " + JSON.stringify(res));
      return res.data;
    }
    return null;
  } catch (e) {
    console.log("e.response.data -> ", JSON.stringify(e.response));
    if (e.response.status === 404) return e.response.data;
    else return null;
  }
};

export const ax_allReservations = async () => {
  try {
    const res = await APICall.get("/api/get/allReservations");
    if (res.status === 200 || res.status === 201) {
      console.log("Res - api allReservations --> " + JSON.stringify(res));
      return res.data;
    }
    return null;
  } catch (e) {
    console.log("e.response.data -> ", JSON.stringify(e.response));
    if (e.response.status === 404) return e.response;
    else return null;
  }
};

export const ax_getSlotsForDateRange_with_startDay = async (
  startDay,
  endDay
) => {
  try {
    const res = await APICall.get(
      `/api/get/getSlotsForDateRange?startDay=${startDay}&endDay=${endDay}`
    );
    if (res.status === 200 || res.status === 201) {
      console.log(
        "Res - api getSlotsForDateRange_with_startDay --> " +
          JSON.stringify(res)
      );
      return res.data;
    }
    return null;
  } catch (e) {
    console.log("e.response.data -> ", JSON.stringify(e.response));
    if (e.response.status === 404) return e.response;
    else return null;
  }
};
